import { useQuery } from '@tanstack/react-query';
import { AlertRuleApi } from '../../../apis/AlertRuleApi/AlertRuleApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IAlertRuleConfiguration } from '../Alert';

export function useAlertRuleConfigurations(alertRuleId?: number) {
    return useQuery<IAlertRuleConfiguration[]>({
        queryKey: [QueryKeys.alertRuleConfigurations, alertRuleId],
        queryFn: () => AlertRuleApi.getAlertRuleConfigurations(alertRuleId!),
        enabled: !!alertRuleId,
    });
}
